export default __webpack_public_path__ + "static/media/rejected.160d84d1.svg";